import { Translation } from "./configmap";
import { SearchQuery } from "../../documentSet/interfaces/api";
import { CategorizationEvent } from "../../metadata/interfaces/categorizationEvents";

export interface ConfigMapDto {
  id: string;
  name: string;
}

export interface GroupBlockDto {
  id: string;
  index: number;
}

export interface EntityTypeDto {
  id: string;
  name: string;
  categorizationLinks: Array<CategorizationLinkDto>;
}

export interface CategorizationLinkDto {
  id: string;
  categorization: ICategorization;
  configMapId?: string;
  groupBlockId?: string;
  entityType?: EntityTypeDto;
  required?: boolean;
}

export interface ICategory {
  id: string;
  visibleValue: string;
  value: string;
}

export interface ICategorization {
  id: string;
  index: number;
  label: Translation;
  /** Absent on a categorization with no search configured, which the API returns as null. */
  search?: SearchQuery;
  events?: Array<CategorizationEvent>;
  categories?: Array<ICategory>;
  entityTypes?: Array<{ id: string }>;
  setType: string;
  widthInPx?: number;
}

export interface CategorizationWithConfig {
  id: string;
  categorization: ICategorization;
  required?: boolean;
}

export enum CategorizationSetType {
  FIXED = "FIXED",
  DYNAMIC = "DYNAMIC",
  DERIVED = "DERIVED",
}

export interface CategorizationAnnotation {
  documentId: string;
  categorizationId: string;
  externalDataId: string;
  groupBlockId?: string;
  index: number;
  originalIndex?: number;
  isByUser?: boolean;
  visibleValue?: string;
  value?: string;
  isLoading?: boolean;
}

export interface CategorizationAnnotationCreate {
  documentId: string;
  categorizationId: string;
  externalDataId: string;
  index: number;
  isByUser: boolean;
  isByDefault: boolean;
  // Legacy fields - used to create DocumentCategoryAnnotation for backwards compatibility
  categoryValue?: string;
  categoryVisibleValue?: string;
}

export interface CategorizationAnnotationRemove {
  documentId: string;
  categorizationId: string;
  groupBlockId?: string;
  index: number;
}

export interface CategorizationAnnotationRemoveByGroupBlockIndex {
  documentId: string;
  categorizations: Array<ICategorization>;
  groupBlockIndex: number;
  isGroupBlockRemoved: boolean;
}

export interface CategorizationAnnotationRemoveByCategorizations {
  documentId: string;
  categorizations: Array<ICategorization>;
}

export interface UpdateMultiGroupBlockCategorizationAnnotation {
  categorizations: Array<ICategorization>;
  groupBlockIndex: number;
  addBefore?: boolean;
}

export interface CategorizationState {
  categorizationAnnotations: Array<CategorizationAnnotation>;
}

export interface BlockingCategorization {
  categorizationId: string;
  groupBlockId?: string;
  index: number;
}
